import type { PublicApiKey } from '#packages/apilib';
import type { createSelectionApi } from './selectionWrapper';

export const SelectionApiKey: PublicApiKey<typeof createSelectionApi> = {
  name: 'SelectionApi',
  public: true,
};
